import PromisedResource from './PromisedResource'

export default class AdCampaignsResource extends PromisedResource {
  constructor({ remote, adAccount }) {
    super(remote.query(q => q.findRelatedRecords(adAccount, 'adCampaigns')))
  }
}
